import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { VecinosSeguridadRoutingModule } from './vecinos-seguridad.routing.module';
import { VecinosSeguridadComponent } from './listado/vecinos-seguridad.component';

@NgModule({
  declarations: [VecinosSeguridadComponent],
  imports: [CommonModule, AuxiliaresModule, VecinosSeguridadRoutingModule],
})
export class VecinosSeguridadModule {}
